module.exports = __webpack_public_path__ + "static/img/zidongjieting2.c6f3fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zidongjieting2.png
// module id = BCH4
// module chunks = 24